import { BROADCAST_SET_ATTENDEE_PRESENCE } from '../Types';

function setAttendeePresence(attendeeId, present) {
  return (dispatch, getState) => {
    const { attendeePresence } = getState();
    /**
     * Adds attendee ids if present is true not within the state array
     * and removed attendee ids from state it exist and present is false.
     */
    const index = attendeePresence.indexOf(attendeeId);
    if (index <= -1 && present) {
      attendeePresence.push(attendeeId);
    } else {
      attendeePresence.splice(index, 1);
    }

    const action = {
      type: BROADCAST_SET_ATTENDEE_PRESENCE,
      payload: attendeePresence
    };
    dispatch(action);
  };
}

export default setAttendeePresence;
